import { useAuth } from "react-oidc-context";
import ButtonSave from "@View/components/buttons/ButtonSave";
import LoadingIcon from "@View/components/svgComponents/LoadingIcon";
import React, { useState, useEffect } from "react";
import { loginByAccessToken } from "@State/effects/security/login";

const box: any = {
  width: "100%",
};
const error: any = {
  color: "red",
};

const KeycloakSignInButton = () => {
  const auth = useAuth();
  const [loginError, setLoginError] = useState<string | null>(null);
  const [isProcessing, setIsProcessing] = useState(false);

  useEffect(() => {
    // Only process if authenticated with Keycloak and not already processing
    if (auth.isAuthenticated && auth.user?.access_token && !isProcessing && !loginError) {
      setIsProcessing(true);

      loginByAccessToken(auth.user.access_token).then((success) => {
        if (success) {
          window.location.reload();
        } else {
          // Backend rejected the Keycloak token - sign out from Keycloak to prevent loop
          setLoginError("Не удалось авторизоваться. Попробуйте снова.");
          auth.signoutSilent().catch(() => {
            // Ignore signout errors
          });
          setIsProcessing(false);
        }
      });
    }
  }, [auth.isAuthenticated, auth.user?.access_token, isProcessing, loginError]);

  if (auth.isLoading || isProcessing) {
    return <LoadingIcon />;
  }

  if (auth.error) return <div style={error}>Error: {auth.error?.message}</div>;

  if (loginError) return <div style={error}>{loginError}</div>;

  return (
    <div style={box}>
      <ButtonSave
        marginTop={null}
        marginBottom={"40px"}
        onClick={(e) => {
          e.preventDefault();
          setLoginError(null);
          auth.signinRedirect();
        }}
      >
        buttons.LogInKeycloak
      </ButtonSave>
    </div>
  );
};

export default KeycloakSignInButton;

